import { DOMSerializer } from 'prosemirror-model';
import { DOMParser } from './parser.js';
export function getHTMLFromFragment(fragment, schema) {
    const documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement('div');
    container.appendChild(documentFragment);
    return container.innerHTML;
}
function elementFromString(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    return new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
}
export function getNodeFromHTML(html, schema) {
    const frag = elementFromString(html);
    return DOMParser.fromSchema(schema).parse(frag, {
        preserveWhitespace: true,
    });
}
export function getSliceFromHTML(html, schema) {
    const frag = elementFromString(html);
    return DOMParser.fromSchema(schema).parseSlice(frag, {
        preserveWhitespace: true,
    });
}
//# sourceMappingURL=html-serializer.js.map